<template>
	<div>
		<div class="buttons is-centered">
			<button
				v-for="option in options"
				:key="option.key"
				v-text="option.term"
				@click="toggleSelection(option.key)"
				class="button is-blue"
				:class="{ 'is-outlined': !selection.includes(option.key) }"
			></button>
		</div>
	</div>
</template>

<script>

import filterMixin from '../../mixins/filter.js';

export default {
	mixins: [filterMixin],

	methods: {
		/* Analytics event id for this component's selection events */
		analyticsEventName(key) {
			return `customer-story-filter-button-${key}`;
		},
	},
};

</script>
